/* eslint-disable */
<div style="max-width:403px;max-height:300px" id="container123"></div>
<template>
    <section class="section section-white content-padded" onload="init()">
        <el-card header="直播预告" shadow="never" v-loading="loader">
            <el-form ref="form" :model="form" label-width="110px">
                <el-form-item label="主播名称">
                    <el-input v-model="form.nickname" placeholder="主播名称" style="width: 55%;" disabled=""></el-input>
                </el-form-item>
                 <el-form-item label="分类">
                    <el-select size="small" v-model="form.cate_id" clearable placeholder="请选择直播分类">
                        <el-option v-for="item in category" :key="item.value" :label="item.cate_name" size="mini" :value="item.cate_id"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input v-model="form.sort" placeholder="0" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="主讲人">
                    <el-input v-model="form.speaker" placeholder="张三" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="主讲人简介">
                    <el-input v-model="form.speaker_desc" placeholder="XX专家" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="直播标题">
                    <el-input v-model="form.title" placeholder="直播标题" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="直播简介">
                    <el-input v-model="form.description" placeholder="直播简介" style="width: 55%;"></el-input>
                </el-form-item>
                <el-form-item label="视频详情">
                    <!-- <quill-editor ref="text" v-model="form.content" class="myQuillEditor"  style="width: 55%;" /> -->
                    <vue-html5-editor :content="form.content" ref="editor" style="width: 55%;" @change="updateContent" :height="360"></vue-html5-editor>
                    <span class="tpl_item img" @click="addImgPreview" style="">
                      <i class="iconfont icon-image"></i>图片
                    </span>
                    <imgPicker :dialog-visible="thumbDialog" :sc-status="isGetThumb" :isMost="true" @chooseImg="pickThumb" @closeImgDialog="closeThumbDialog"></imgPicker>
                </el-form-item>
                <el-form-item label="直播开始时间">
                    <el-date-picker
                            v-model="form.start_at"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm"
                            default-time="00:00:00"
                            :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="直播间封面图片">
                    <div @click="handleImgPicker('cover_image')" class="upload-box">
                        <img v-if="form.cover_image" :src="form.cover_image" class="avatar"/>
                        <i v-else class="iconfont icon-camera avatar-uploader-icon"></i>
                    </div>
                    <div class="frm-tips">只能上传jpg/png文件，且不超过2M </div>
                </el-form-item>
                <el-form-item label="视频类型" prop="source_video_type">
                    <el-select v-model="form.source_video_type_text"  placeholder="视频类型" @change="handleVideoTypeChange" disabled>
                        <el-option  v-for="item in sourceVideoTypeOption" :key="item.key" :label="item.name" :value="item.value" >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col ><el-input v-model="form.source_video_type" placeholder=""></el-input></el-col>
                    </div>
                </el-form-item>
                <!--<el-form-item label="商城商品选择" :md="10">
                    <el-select v-model="relItemsShops" filterable placeholder="请输入商品编号" remote :remote-method="getItemShopsList" @change="handleItemShopsChange" multiple>
                        <el-option
                                v-for="item in relItemsShopsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                        >
                        </el-option>
                    </el-select>
                    <div v-show="false">
                        <el-col ><el-input v-model="relItemsShopsVal" placeholder=""></el-input></el-col>
                    </div>
                </el-form-item>-->
                <el-card header="店铺商品选品" shadow="naver">
                    <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
                </el-card>

                <div class="section-footer with-border content-center">
                    <el-button size="large" @click="cancelSubmit">取消</el-button>
                    <el-button type="primary" @click="submitItemsActionConfirm" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
                </div>
                <imgPicker :dialog-visible="imgDialog" :sc-status="isGetImage" @chooseImg="pickImg" @closeImgDialog="closeImgDialog"></imgPicker>
            </el-form>
        </el-card>
    </section>
</template>
<script>
    import imgPicker from '@/components/imageselect'
    import SkuSelector from '@/components/function/skuSelector'
    import { getDistributorList } from '../../../api/marketing'
    import {
        saveAnchor,
        getAnchorDetail,
        savePreNotice,
        getShopItemsDetail,
        getLiveConf,
        getCateList,
    } from '../../../api/live'
    import richTextEditor from '@/components/function/richTextEditor'
    export default {
        data () {
            return {
                pickerOptions : {
                    disabledDate (time) {
                        return time.getTime() < Date.now() - 86400000
                    },
                },
                relItemsShopsList:[],
                thumbDialog:false,
                isGetThumb: false, 
                submitLoading: false,
                form: {
                    anchor_id:'',
                    cover_image:'',
                    description:'',
                    end_at:'',
                    inca_id:'',
                    is_record:'true',
                    item_bn:'',
                    live_id:'',
                    source_video_type:'',
                    source_video_url:'',
                    title:'',
                    speaker:'',
                    speaker_desc:'',
                    content:'',
                    cate_id:1,
                    sort:0,
                    source_video_type_text:'',
                    distributor_name:'',
                    // items:{
                    //     store:[],
                    //     shops:[],
                    // },
                    storeItem:[],
                    shopsItem:[],
                },
                sourceVideoTypeOption: [
                    {name: "直播", value: 'live'},
                    {name: "录播", value: 'record'},
                    {name: "上传视频", value: 'upload'},
                ],
                imgDialog:false,
                isGetImage:false,
                pickerImgType:'cover_image',
                loader:'',
                relItems: [],
                category:[],
                relItemsShops:"",
                relItemsShopsVal:"",
            }
        },
        components: {
            imgPicker,
            SkuSelector,
        },
        methods: {
            cancelSubmit () {
                this.$router.go(-1)
                // this.$router.push({ path: this.matchInternalRoute('livelist'),query:{}})
            },
            submitItemsActionConfirm () {
                this.submitLoading = true
                savePreNotice(this.form).then(res => {
                    this.submitLoading = false
                    this.$message({ type: 'success', message: '保存成功'})
                    if (this.$store.getters.login_type != 'distributor') {
                        this.$router.go(-1)
                    }
                }).catch (error => {
                    this.submitLoading = false
                })
            },
            addImgPreview: function () {
                this.thumbDialog = true
                this.isGetThumb = true
            },
            closeThumbDialog: function () {
                this.thumbDialog = false
            },
            updateContent: function (data) {
                this.form.content = data
            },
            pickThumb: function (arr) {
                if (arr.length != 0) {
                  arr.forEach(data => {
                    if (data && data.url !== '') {
                      this.thumbDialog = false
                      var index = this.$refs.editor.$el.id
                      var loc = this.$refs.editor
                      var img = new Image()
                      img.src = this.wximageurl + data.url
                      if (loc.range) {
                        loc.range.insertNode(img)
                        var referenceNode = loc.range.endContainer
                        if (referenceNode.className !== 'content') {
                          loc.range.setStartAfter(referenceNode)
                        } else {
                          loc.range.setStart(loc.range.endContainer, loc.range.endOffset)
                        }
                      } else {
                        loc.$refs.content.appendChild(img)
                        loc.focus()
                        loc.restoreSelection()
                      }
                      this.form.content = loc.$refs.content.innerHTML
                    }
                  })
                }
              },
            pickImg (data) {
                if (this.pickerImgType == 'cover_image') {
                    this.form.cover_image = data.url
                }
                this.imgDialog = false
            },
            handleImgPicker(pickerImgType) {
                this.pickerImgType = pickerImgType
                this.imgDialog = true
                this.isGetImage = true
            },
            closeImgDialog () {
                this.imgDialog = false
                this.isGetImage = false
            },
            handleVideoTypeChange:function (val){
                this.form.source_video_type = val
            },
            getItems(data) {
                let items = []
                data.forEach(item => {
                    items.push(item.itemId)
                })
                this.form.storeItem = items
            },
            getItemShopsList(val){
                getShopItemsDetail({page: 1, pageSize: 50,id:val}).then(res => {
                    this.relItemsShopsList = [];
                    for (let item of res.data.data.list) {
                        this.relItemsShopsList.push({name: item.item_name, id: item.item_id})
                    }
                })
            },
            handleItemShopsChange:function (val){
                this.form.shopsItem = val
            },
        },
        mounted () {
            getLiveConf().then(res=>{
                if(res.data){
                    this.sourceVideoTypeOption = res.data.source_video_type
                }
            })
            getCateList({page:1,pageSize:-1}).then(res=>{
                if(res.data){
                    this.category = res.data.data.list

                }
            })
            this.anchor_id = this.$route.params.id
            getAnchorDetail(this.$route.params).then(res => {
                if(res.data){
                    if(this.anchor_id){
                        this.is_new = false;
                    }
                    res.data.data.disabled = res.data.data.disabled ?  '1' : '0';
                    this.form = res.data.data
                    this.form.source_video_type_text = '预告'
                    this.form.source_video_type = 'prelive'
                }
            });

        },

    }
</script>

<style lang="scss">
    .bm-view {
        width: 100%;
        height: 300px;
    }
    #qqmap_rslist {
        border-right: 1px solid #e7e7eb;
    }
    #qqmap_container{
        float:left;
        width:800px;
        height:400px;
    }
    .checkbox {
        background-color: white;
        border-radius: 0px;
        border: 1px solid #d3d3d3;
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        line-height: 20px;
    }
</style>



// WEBPACK FOOTER //
// prenotice.vue?820b185c